import { InjectionToken } from '@angular/core';

/**
 * Base URL du storage public Laravel (médias : photos produits, logos…),
 * ex. `http://localhost:8080/storage`. Fournie depuis `Env.storageBaseUrl`
 * (cf. app.config.ts) pour construire les URLs d'assets sans coder l'hôte en dur.
 */
export const STORAGE_BASE_URL = new InjectionToken<string>('STORAGE_BASE_URL');
